define(
    'modules/notification',[
        'jquery',
    ],

    function ($) {
        /**
         * Notification constructor
         * @constructor
         */
        function Notification(el) {
            this.el = el;

            this._init();
        }

        /**
         * Shows the notification by sliding down.
         *
         * @method show
         */
        Notification.prototype.show = function () {
            var self = this;

            this.el.slideDown(200);
        };

        /**
         * Hide the notification by sliding up.
         *
         * @method _hide
         * @param remove
         * @private
         */
        Notification.prototype.hide = function (remove) {
            this.el.slideUp(200);
        };

        /**
         * Inits component: move it to top, and set bind close-button.
         *
         * @method loadTemplate
         * @param callback
         */
        Notification.prototype._init = function (callback) {
            var self = this;

            this.el.detach();
            $('body').prepend(this.el);

            this.el.find('.notification__close').on('click', function () {
                self.hide();
            });
        };

        return Notification;
    }
);

